
















































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import { SelectItemString } from "@/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import TimePicker from "@/components/common/TimePicker.vue";
@Component({
  components: { EditDayChangePicker, TimePicker }
})
export default class BasicInfo6 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() patient_information_codes!: SelectItemString[]; //利用者情報コード
  @Prop() location_codes!: SelectItemString[]; //場所コード
  @Prop() end_visit_status_codes!: SelectItemString[]; //訪問終了の状況コード

  //TimePickerなので以下処理必須
  get VisitEndHH() {
    return this.tab.visit_end_date_hh;
  }
  set VisitEndHH(newValue: string) {
    if (newValue == null) {
      this.tab.visit_end_date_hh = "";
    } else {
      this.tab.visit_end_date_hh = String(newValue);
    }
  }

  get VisitEndMM() {
    return this.tab.visit_end_date_mm;
  }
  set VisitEndMM(newValue: string) {
    if (newValue == null) {
      this.tab.visit_end_date_mm = "";
    } else {
      this.tab.visit_end_date_mm = String(newValue);
    }
  }

  get DieDateHH() {
    return this.tab.die_date_hh;
  }
  set DieDateHH(newValue: string) {
    if (newValue == null) {
      this.tab.die_date_hh = "";
    } else {
      this.tab.die_date_hh = String(newValue);
    }
  }

  get DieDateMM() {
    return this.tab.die_date_mm;
  }
  set DieDateMM(newValue: string) {
    if (newValue == null) {
      this.tab.die_date_mm = "";
    } else {
      this.tab.die_date_mm = String(newValue);
    }
  }
}
